import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import Axios from 'axios'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { Progress  } from 'antd';
import { api, URL } from '../../api';

export default class Modelupdatetecher extends Component {
        constructor(props) {
                    super(props);
            this.state = {
            modal: false,
            Teacher:[],
            Univ_ID:'1',
            percenddd:'0',
            
            }

            this.Updateteacher = this.Updateteacher.bind(this);
            this.Updateteacherdata = this.Updateteacherdata.bind(this);
            }


        toggle = () => {
            this.setState({
            modal: !this.state.modal
            });
        }


        componentDidMount(){
            setTimeout(() => {
                //ภายใน
                Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/teacher/showteacher/')
                .then(res => {
                //  console.log(res.data.DetailListTeacher);
                //  this.setState({ bankname: res.data, loading: false })
                const user_teacher = res.data.DetailListTeacher.filter( ({ user_teacher }) => user_teacher !== null );
                const user_teacher2 = user_teacher.filter( ({ user_teacher }) => user_teacher.substring(0, 1) !== 'T' );
                this.setState({ Teacher: user_teacher2})
                }) 
            }, 0);

        }

        Updateteacher() {
                // alert('A name was submitted: ' + this.state.value);  
                //  console.log(lastnaame )

        //วนลูปอัพเดทข้อมูลอาจารย์
        for (let index = 0; index < this.state.Teacher.length; index++) {


                    const totalp = this.state.Teacher.length;
                    const loops = index+1;
                    const percens = loops / totalp;
                    const percens2 = percens * 100;
                    this.setState ({ percenddd: percens2})

                    const st = this.state.Teacher[index].poname;
                    const nn = st.split(" ");
                    const naame =nn[0];
                    const lastnaame =nn[1];

            const datafrm = new FormData(); 
            datafrm.append("Teacher_Citizen_ID", this.state.Teacher[index].user_teacher);
            datafrm.append("Teacher_PNAME", this.state.Teacher[index].pname);
            datafrm.append("Teacher_NAME", naame);
            datafrm.append("Teacher_LASTNAME", lastnaame);
            datafrm.append("Teacher_PASSWORD", this.state.Teacher[index].pass_teacher);
            datafrm.append("Teacher_faculty", this.state.Teacher[index].faculty);
            datafrm.append("Univ_ID", this.state.Univ_ID);
            
            api.post("index/Updateteacher/",datafrm,{
            headers: {
                'content-type': 'multipart/form-data'
            }
        })

        .then(res => {
        
                }) 
                  
         }
     }


     Updateteacherdata() {
        // alert('A name was submitted: ' + this.state.value);  
        //  console.log(lastnaame )

//วนลูปอัพเดทข้อมูลอาจารย์
for (let index = 0; index < this.state.Teacher.length; index++) {


            const totalp = this.state.Teacher.length;
            const loops = index+1;
            const percens = loops / totalp;
            const percens2 = percens * 100;
            this.setState ({ percenddd: percens2})

            const st = this.state.Teacher[index].poname;
            const nn = st.split(" ");
            const naame =nn[0];
            const lastnaame =nn[1];

    const datafrm = new FormData(); 
    datafrm.append("Teacher_Citizen_ID", this.state.Teacher[index].user_teacher);
    datafrm.append("Teacher_PNAME", this.state.Teacher[index].pname);
    datafrm.append("Teacher_NAME", naame);
    datafrm.append("Teacher_LASTNAME", lastnaame);
    datafrm.append("Teacher_PASSWORD", this.state.Teacher[index].pass_teacher);
    datafrm.append("Teacher_faculty", this.state.Teacher[index].faculty);
    datafrm.append("Univ_ID", this.state.Univ_ID);
    
    api.post("index/Updateteacherdata/",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
})

.then(res => {

        })   
 }
}


    render() {
      //  console.log(this.state.Teacher.length)
        return (
            <div >
                 
                    <MDBBtn color="secondary" onClick={this.toggle} >อัพเดทข้อมูลผู้สอน</MDBBtn>
                    <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
                        <MDBModalHeader toggle={this.toggle}>อัพเดทข้อมูลผู้สอน</MDBModalHeader>
                        <MDBModalBody>
                                <Progress
                                    type="circle"
                                    strokeColor={{
                                        '0%': '#108ee9',
                                        '100%': '#87d068',
                                    }}
                                    percent={this.state.percenddd}
                                />
                           <MDBBtn color="indigo" onClick={this.Updateteacher}>อัพเดตเดี่ยวนี้</MDBBtn>
                           <MDBBtn color="indigo" onClick={this.Updateteacherdata}>ดึงข้อมูลคณะ</MDBBtn>
                        </MDBModalBody>
                        <MDBModalFooter>
                        <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                        {/* <MDBBtn color="primary">Save changes</MDBBtn> */}
                        </MDBModalFooter>
                    </MDBModal>
              
            </div>
        )
    }
}
